import { render, staticRenderFns } from "./SimpleTrunkAnalysis2.vue?vue&type=template&id=da50a462&scoped=true"
import script from "./SimpleTrunkAnalysis2.vue?vue&type=script&lang=ts"
export * from "./SimpleTrunkAnalysis2.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTrunkAnalysis2.vue?vue&type=style&index=0&id=da50a462&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da50a462",
  null
  
)

export default component.exports